import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { usePageSettings } from "../contexts/PageSettingsContext";
import { useSelectedPlanContext } from "../contexts/SelectedPlanContext";
import React from "react";

const fetchLocations = async (service) => {
	const response = await fetch(`${process.env.GATSBY_LOCATION_ENDPOINT}${service}&flag=1`);
	if (!response.ok) throw new Error("Failed to fetch locations");

	const data = await response.json();
	return data;
};

export const useFetchLocations = (service, iataCode) => {
	const { changeSelectedLocation } = usePageSettings();
	const { changeSelectedPlan } = useSelectedPlanContext();

	const query = useQuery({
		queryKey: ["locations", service, iataCode],
		queryFn: () => fetchLocations(service),
		refetchOnWindowFocus: false,
		enabled: !!service,
	});

	// Controlled side-effect when data is ready
	React.useEffect(() => {
		if (query.data && query.data.length > 0) {
			const filtered = query.data.find((pop) => pop.iata_code === iataCode);

			const locationToSet = filtered ?? {
				name: query.data[0].name,
				iata_code: query.data[0].iata_code,
				iso_code: query.data[0].iso_code,
				flag: query.data[0].flag,
			};

			changeSelectedLocation(locationToSet);

			changeSelectedPlan((prev) => {
				if (prev?.id && prev.location_code !== locationToSet.iata_code) {
					return undefined;
				}
				return prev;
			});
		}
	}, [query.data, iataCode]);

	return query;
};

export const useAllLocations = () => {
	const fetchAllLocations = async () => {
		const res = await fetch(process.env.GATSBY_LOCATION_ENDPOINT);
		if (!res.ok) {
			throw new Error(`Failed to fetch all locations: ${res.status}`);
		}
		const data = await res.json();
		// optional: sort by `order` if your items have that field
		// return data.sort((a, b) => a.order - b.order);
		return data;
	};

	return useQuery({
		queryKey: ["allLocations"],
		queryFn: fetchAllLocations,
		refetchOnWindowFocus: false,
		// you can also handle errors here if you like:
		// onError: (err) => console.error(err),
	});
};
